__turbopack_context__.v({
  "acheivername": "upsc-psir-optional-module__ysdZXq__acheivername",
  "acheivername1": "upsc-psir-optional-module__ysdZXq__acheivername1",
  "acheiverrank": "upsc-psir-optional-module__ysdZXq__acheiverrank",
  "acheiverrank1": "upsc-psir-optional-module__ysdZXq__acheiverrank1",
  "acheiverrank2": "upsc-psir-optional-module__ysdZXq__acheiverrank2",
  "acheiverrank3": "upsc-psir-optional-module__ysdZXq__acheiverrank3",
  "acheiverrank4": "upsc-psir-optional-module__ysdZXq__acheiverrank4",
  "acheivertitle": "upsc-psir-optional-module__ysdZXq__acheivertitle",
  "ansheet": "upsc-psir-optional-module__ysdZXq__ansheet",
  "bgboxbg": "upsc-psir-optional-module__ysdZXq__bgboxbg",
  "captcha": "upsc-psir-optional-module__ysdZXq__captcha",
  "checkboxcontent": "upsc-psir-optional-module__ysdZXq__checkboxcontent",
  "classesborder": "upsc-psir-optional-module__ysdZXq__classesborder",
  "contactbox": "upsc-psir-optional-module__ysdZXq__contactbox",
  "contactboxheight": "upsc-psir-optional-module__ysdZXq__contactboxheight",
  "contactsubcontent": "upsc-psir-optional-module__ysdZXq__contactsubcontent",
  "gshad": "upsc-psir-optional-module__ysdZXq__gshad",
  "img": "upsc-psir-optional-module__ysdZXq__img",
  "imgboxbelow": "upsc-psir-optional-module__ysdZXq__imgboxbelow",
  "invalidCheck2": "upsc-psir-optional-module__ysdZXq__invalidCheck2",
  "mainshead": "upsc-psir-optional-module__ysdZXq__mainshead",
  "mbtableheading": "upsc-psir-optional-module__ysdZXq__mbtableheading",
  "medalicon": "upsc-psir-optional-module__ysdZXq__medalicon",
  "mobhead": "upsc-psir-optional-module__ysdZXq__mobhead",
  "mobilemaillinks": "upsc-psir-optional-module__ysdZXq__mobilemaillinks",
  "more": "upsc-psir-optional-module__ysdZXq__more",
  "normalbutton": "upsc-psir-optional-module__ysdZXq__normalbutton",
  "normalbutton2": "upsc-psir-optional-module__ysdZXq__normalbutton2",
  "pagemaintitle": "upsc-psir-optional-module__ysdZXq__pagemaintitle",
  "paybill": "upsc-psir-optional-module__ysdZXq__paybill",
  "paybills": "upsc-psir-optional-module__ysdZXq__paybills",
  "redunderline": "upsc-psir-optional-module__ysdZXq__redunderline",
  "sectiontitle": "upsc-psir-optional-module__ysdZXq__sectiontitle",
  "sectiontitle1": "upsc-psir-optional-module__ysdZXq__sectiontitle1",
  "sectiontitle2": "upsc-psir-optional-module__ysdZXq__sectiontitle2",
  "subhead": "upsc-psir-optional-module__ysdZXq__subhead",
  "tableheading": "upsc-psir-optional-module__ysdZXq__tableheading",
  "tablepara": "upsc-psir-optional-module__ysdZXq__tablepara",
  "tablepara1": "upsc-psir-optional-module__ysdZXq__tablepara1",
  "tablescroll": "upsc-psir-optional-module__ysdZXq__tablescroll",
  "toppersupsc": "upsc-psir-optional-module__ysdZXq__toppersupsc",
  "viewbutton": "upsc-psir-optional-module__ysdZXq__viewbutton",
});
